export const SERVER_URL = "https://ifw.wealthcentral.com/instreamapi";
//export const SERVER_URL = "https://ifw.instreamwealth.com/instreamapi";
export const API_KEY =  "c4ffa231-1eec-4f9d-a37d-59403dbc4a03-84e2f5f1-e3d9-44dc-9b16-a7ee674421f2";
export const SALES_COOKIE_AGE = 60 * 60 * 24;
